module.exports = "<div class=\"gw-modal-header\">\r\n    <h3>{{ title }}</h3>\r\n</div>\r\n<div class=\"gw-modal-body\">\r\n    <div class=\"gw-message\">\r\n        <p ng-bind-html=\"message\"></p>\r\n        <p class=\"gw-description\" ng-show=\"description\">{{ description }}</p>\r\n    </div>\r\n</div>\r\n<div class=\"gw-modal-footer\">\r\n    <button ng-click=\"$close()\" class=\"gw-btn {{ action.btnClass }}\">{{ action.label}}</button>\r\n    <button ng-if=\"showCancelBtn\" ng-click=\"$dismiss()\" class=\"gw-btn cancelBtn\">{{ cancelBtnLabel}}</button>\r\n</div>\r\n"


/*****************
 ** WEBPACK FOOTER
 ** ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/platform/widgets/modal/templates/address-hard-error-template.html
 ** module id = 519
 ** module chunks = 0
 **/